import React from "react";
import { ElementsPreview } from "./ElementsPreview";
import {
  FluidElement,
  Breakpoint,
  ElementType,
  ButtonDesignSize,
  ButtonSettings,
  ImageSettings,
  ImageSize,
  TextObject,
  WuiltContext,
} from "@/shared/types";

interface ElementProps {
  element: FluidElement;
  type: ElementType;
  text: TextObject;
  sectionId: string;
  sectionValueId: string;
  breakpoint: Breakpoint;
  wuiltContext: WuiltContext;
  gridMaxWidth: string;
  gridContainerWidth: number;
}

export const ElementPreview: React.FC<ElementProps> = ({
  element,
  type,
  text,
  sectionId,
  sectionValueId,
  breakpoint,
  wuiltContext,
  gridContainerWidth,
}) => {
  const layout = element?.layout[breakpoint];
  const Component = ElementsPreview[type!];

  const horizontalAlignment =
    element?.layout[breakpoint]?.alignment?.horizontal;
  const verticalAlignment = element?.layout[breakpoint]?.alignment?.vertical;

  const shouldImageFill =
    (element?.settings as ImageSettings)?.design?.size === ImageSize.Cover;

  const shouldButtonFill =
    (element?.settings as ButtonSettings)?.design?.size ===
    ButtonDesignSize.Fill;

  const isMobileNotUpdated =
    breakpoint === Breakpoint.Mobile && !element?.layout?.mobile?.isUpdated;

  return (
    <div
      style={{
        position: "absolute",
        zIndex: layout?.zIndex,
        top: `${layout?.offset?.top}px`,
        left: isMobileNotUpdated
          ? "unset"
          : `${(layout?.offset?.left / 100) * gridContainerWidth}px`,
        width: `${(layout?.size?.width! / 100) * gridContainerWidth}px`,
        height: `${layout?.size?.height}px`,
        minWidth: isMobileNotUpdated ? "100%" : undefined,
        margin: isMobileNotUpdated ? "0 auto" : undefined,

        // position: pinSettings?.position ? "sticky" : "absolute",
        // top: isMiddlePosition
        //   ? "50%"
        //   : isTopPosition
        //   ? pinSettings?.offset + "px"
        //   : "unset",
        // bottom:
        //   pinSettings?.position === "bottom"
        //     ? pinSettings?.offset + "px"
        //     : "unset",
      }}
    >
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: horizontalAlignment ?? "start",
          alignItems: verticalAlignment ?? "start",
          textAlign: horizontalAlignment ?? "start",
        }}
      >
        <div
          style={{
            wordBreak: "break-word",
            width:
              element?.type === ElementType.Text ||
              element?.type === ElementType.Counter ||
              element?.type === ElementType.SocialLinks ||
              element?.type === ElementType.AppStoreButton ||
              (element?.type === ElementType.Button && !shouldButtonFill) ||
              (element?.type === ElementType.Image && !shouldImageFill)
                ? "fit-content"
                : "100%",

            height:
              element?.type === ElementType.Embed ||
              element?.type === ElementType.Video ||
              element?.type === ElementType.Image ||
              element?.type === ElementType.Button
                ? (element?.type === ElementType.Button && !shouldButtonFill) ||
                  (element?.type === ElementType.Image && !shouldImageFill)
                  ? "fit-content"
                  : "100%"
                : undefined,
          }}
        >
          <Component
            text={text}
            element={element}
            elementSize={{
              ...layout?.size,
              width: ((layout?.size?.width ?? 10) / 100) * gridContainerWidth,
            }}
            breakpoint={breakpoint}
            sectionId={sectionId}
            sectionValueId={sectionValueId}
            wuiltContext={wuiltContext}
          />
        </div>
      </div>
    </div>
  );
};
